import React from 'react';
import ReactTable from '../../../../../../components/Table';
import Typography from '../../../../../../components/Typography';
import { Parser } from "html-to-react";
import { SSLTLSColors, tlsColors } from '../../../../../../utils/constants/asset';
import BarChartComponent from '../../../../../../components/Widgets/barChart';

const Insight6 = (props) => {
    const { data } = props;
    const htmlParser = new Parser();

    const columns = [
        {
            Header: 'Asset',
            accessor: 'asset',
        },
        {
            Header: 'Weak Cipher Suites',
            accessor: 'weakCipherSuitesCount',
            disableSortBy: true,
        }
    ];

    const tableData = data?.data?.map((item, index) => {
        return ({
            asset: item?.assetName,
            weakCipherSuitesCount: item?.weakCipherSuitesCount
        })
    });

    const graphData = [];
    data?.graphData?.map((graph) => {
        graphData.push({
            name: graph?.name?.toUpperCase(),
            value: graph?.count
        });
    });

    return (
        <div className='insight-container flex-[100%]'>
            <div className='upper-section'>
                <div className='description'>
                    <Typography variant={"h7"} className={"text-headings"}>Observation</Typography>
                    <div>
                        {htmlParser.parse(data?.observation)}
                    </div>
                    <Typography variant={"h7"} className={"text-headings mt-5"}>Recommended Action</Typography>
                    <div>
                        {htmlParser.parse(data?.recommended_action)}
                    </div>
                </div>
                <div className='graph stackedbar-container'>
                    {
                        data?.graphData &&
                            <BarChartComponent 
                                className={"flex flex-row h-[250px] insight2-bar-chart mt-5"}
                                labelHeight="h-[50px]"
                                graphData={graphData || []} 
                                colors={tlsColors}
                            />
                    }
                </div>
            </div>
            <div className='lower-section'>
                <div className='pentest mr-5'>
                    <div className='xl:col-span-12 heading mb-5'>
                        <Typography variant={"h7"} className={"text-headings"}>Assets</Typography>
                    </div>
                    {
                        data?.data &&
                            <ReactTable
                                columns={columns}
                                data={tableData || []}
                                className={"table lg:table-fixed middle-aligned"}
                                headerClassName={"background rounded sticky z-[5] top-0"}
                                bodyClassName={"text-headings"}
                            />
                    }
                </div>
            </div>
        </div>
    );
};

export default Insight6;